import BlogTwentySevenContainer from "./container/BlogTwentySevenContainer";
export default BlogTwentySevenContainer;
